<template>
  <div class="field-group" :class="{ 'field-group-full': fullWidth }">
    <label class="field-label-compact">
      {{ label }}<span class="required-asterisk">*</span>
    </label>
    <el-input
      :model-value="modelValue"
      :type="type"
      class="field-input-compact"
      :class="{ 'field-error': invalid }"
      size="large"
      :placeholder="placeholder"
      @update:model-value="emit('update:modelValue', $event)"
    />
    <span v-if="invalid" class="field-error-message">
      {{ errorMessage }}
    </span>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    modelValue: string;
    label: string;
    placeholder: string;
    type?: string;
    fullWidth?: boolean;
    invalid?: boolean;
    errorMessage?: string;
  }>(),
  { type: undefined, fullWidth: false, invalid: false, errorMessage: '' },
);

const emit = defineEmits<{ 'update:modelValue': [value: string] }>();
</script>

<style scoped src="./fields.css"></style>
<style scoped src="./inputs.css"></style>
